<template>
  <v-container>
    <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>
    <v-row class="mt-10" align="center" justify="center">
      <v-col class="text-center">
        <span class="text-tcdc-green header bold">
          {{$t('our-service.title')}}
        </span>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <span class="sub-header2 text-tcdc-grey1 bold">
          {{$t('our-service.content')}}
        </span>
      </v-col>
    </v-row>
    <v-row class="my-5">
      <v-layout :column="$vuetify.breakpoint.smAndDown">
        <v-flex md4 mb-5 mb-md-0 v-for="(item, i) of imagesList" :key="i">
          <OurServiceCard :item="item" @onPress="routeTo(item.path)" />
        </v-flex>
      </v-layout>
    </v-row>
  </v-container>
</template>

<script>
import OurServiceCard from "../../components/cards/OurServiceCard";
import GreenButton from "../../components/buttons/GreenButton";
import { mapState } from "vuex";

export default {
  components: {
    OurServiceCard,
    // GreenButton
  },
  created() {
    this.items[0].text = this.branchName;
    this.imagesList = [
      {
        id: 1,
        header: this.$t('our-service.idea'),
        content: this.$t('our-service.idea-content'),
        image_path: require("../../assets/our_service/idea.png"),
        path: "/our-service/idea-generation"
      },
      {
        id: 2,
        header: this.$t('our-service.startup'),
        content: this.$t('our-service.startup-content'),
        image_path: require("../../assets/our_service/business-startup.png"),
        path: "/our-service/business-startup"
      },
      {
        id: 3,
        header: this.$t('our-service.transform'),
        content: this.$t('our-service.transform-content'),
        image_path: require("../../assets/our_service/business-transformation.png"),
        path: "/our-service/business-transformation"
      }
    ]
  },
  computed: {
    ...mapState({
      branchName: state => state.Branch.branch_name,
      lang: state => state.Branch.lang
    }),
    branchChanged: function () {
      return this.branchName;
    }
  },
  watch: {
    branchChanged: function() {
      this.items[0].text = this.branchChanged;
    },
    lang: function () {
      this.imagesList = [
        {
          id: 1,
          header: this.$t('our-service.idea'),
          content: this.$t('our-service.idea-content'),
          image_path: require("../../assets/our_service/idea.png"),
          path: "/our-service/idea-generation"
        },
        {
          id: 2,
          header: this.$t('our-service.startup'),
          content: this.$t('our-service.startup-content'),
          image_path: require("../../assets/our_service/business-startup.png"),
          path: "/our-service/business-startup"
        },
        {
          id: 3,
          header: this.$t('our-service.transform'),
          content: this.$t('our-service.transform-content'),
          image_path: require("../../assets/our_service/business-transformation.png"),
          path: "/our-service/business-transformation"
        }
      ]
    }
  },
  methods: {
    routeTo(path) {
      this.$router.push(path);
    }
  },
  data: () => ({
    items: [
      {
        text: 'TCDC BANGKOK',
        disabled: false,
        href: "/home"
      },
      {
        text: "OUR SERVICE",
        disabled: true
      }
    ],
    imagesList: []
  })
};
</script>

<style>
</style>
